import type { CodingContext } from '@imprivata-cloud/dataprivacy';
import type {
  DirectoryAddRequest,
  ImprDirResponse,
  CreateClientCredentialRequest,
  CreateClientCredentialResponse,
  ImprIdpDataGetResponse,
  IdpMetadataGetResponse,
} from './types';
import { fetcher } from './utils';
import { Endpoints, SystemType } from './constants';

export const findImprIdpDirectories = async (url: string, isSetup = false): Promise<ImprDirResponse> => {
  return fetcher(url, {
    method: 'POST',
    systemType: isSetup ? SystemType.SETUP : SystemType.PORTAL,
  });
};

export const addImprIdpDirectory = async (url: string, request: DirectoryAddRequest, codingContext?: CodingContext) => {
  return fetcher(url, {
    method: 'POST',
    body: JSON.stringify(request),
    headers: codingContext
      ? {
          'Impr-Coding-Ctx': codingContext.buildImprCodingCtxHeader(),
        }
      : {},
  });
};

export const createClientCredential = async (
  request: CreateClientCredentialRequest,
  isSetup: boolean,
): Promise<CreateClientCredentialResponse> => {
  const url = isSetup ? Endpoints.SETUP_CREATE_CLIENT_CREDENTIAL : Endpoints.PORTAL_CREATE_CLIENT_CREDENTIAL;
  console.log('createClientCredential, isSetup', isSetup);
  return fetcher(url, {
    method: 'POST',
    body: JSON.stringify(request),
    systemType: isSetup ? SystemType.SETUP : SystemType.PORTAL,
  });
};

export async function getImprIdpData(isSetup: boolean): Promise<ImprIdpDataGetResponse> {
  return fetcher(Endpoints.IDP_GET_DATA, {
    method: 'POST',
    systemType: isSetup ? SystemType.SETUP : SystemType.PORTAL,
  });
}

export async function idpGet(isSetup = false): Promise<IdpMetadataGetResponse> {
  return fetcher(Endpoints.IDP_GET, { method: 'POST', systemType: isSetup ? SystemType.SETUP : SystemType.PORTAL });
}
